// src/utils/firebase/paths.js
export const collectionDocPath = (uid, s, y, m, se, ct, cat, num) =>
    `users/${uid}/collection/${s}/${y}/${m}/${se}/${ct}/${cat}/${num}`;
  
  export const setDocPath = (uid, setId) => `users/${uid}/sets/${setId}`;
  export const setItemDocPath = (uid, setId, itemId) => `users/${uid}/sets/${setId}/items/${itemId}`;
  
  export const scopeKeys = (uid, s, y, m, se, ct, cat) => ({
    sport:            `${uid}::${s}`,
    year:             `${uid}::${s}_${y}`,
    manufacturer:     `${uid}::${s}_${y}_${m}`,
    series:           `${uid}::${s}_${y}_${m}_${se}`,
    cardType:         `${uid}::${s}_${y}_${m}_${se}_${ct}`,
    cardTypeCategory: `${uid}::${s}_${y}_${m}_${se}_${ct}_${cat}`,
  });
  
  export const checklistCompositeId = (s,y,m,se,ct,cat) =>
    `${s}_${y}_${m}_${se}_${ct}_${cat}`;